import { render, staticRenderFns } from "./Avos.vue?vue&type=template&id=7de2acde&"
import script from "./Avos.vue?vue&type=script&lang=js&"
export * from "./Avos.vue?vue&type=script&lang=js&"
import style0 from "./Avos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports